import { useCallback, useMemo } from 'react';
import isEmpty from 'lodash/isEmpty';
import { get, has } from 'lodash';
import {
  getParams,
  getUpdatedUrl,
} from '../../CategoryListingPage/molecules/CategoryModuleFilter/views/CategoryModuleFilter';
import { FIT_FILTER, MIN_OFFER_PRICE } from '../constants/QuickFilters.constants';

const useQuickFilters = ({
  appliedFilters,
  formDetails,
  isFacetedNavigationEnabled,
  pathName,
  cleanUrlObj,
  seoFacetedNavigationConfig,
  setUpdatedUrlActn,
  setPriceFilterFlagActn,
  updateBopisFormValue,
}) => {
  const selectedTab = useMemo(() => {
    return appliedFilters[FIT_FILTER];
  }, [appliedFilters]);

  const isSelectedVal = (filters, val) => {
    if (Array.isArray(filters) && filters.length) {
      return filters.some((filter) => val === filter);
    }
    return false;
  };

  const handleRemoveFilters = (key, val) => {
    if (has(appliedFilters, key)) {
      return (
        Array.isArray(appliedFilters[key]) &&
        appliedFilters[key].filter((filterVal) => filterVal !== val)
      );
    }
    return [...appliedFilters[key], val];
  };

  const createNewList = (filters, key, value) => {
    if (
      has(appliedFilters, key) &&
      Array.isArray(appliedFilters[key]) &&
      appliedFilters[key].length &&
      isSelectedVal(get(appliedFilters, key), value)
    ) {
      return handleRemoveFilters(key, value);
    }
    if (key !== FIT_FILTER && key !== MIN_OFFER_PRICE) {
      const newList = isEmpty(filters[key]) ? [] : filters[key];
      newList.push(value);
      return newList;
    }
    return [value];
  };

  const handleFilterSelection = useCallback(
    (key, value) => {
      const { asPath, filtersFromUrl } =
        getParams({
          key,
          newList: createNewList(appliedFilters, key, value),
          formData: formDetails,
          isFacetedNavigationEnabled,
          pathName,
          seoFacetedNavigationConfig,
          cleanUrlObj,
        }) || {};
      const updatedUrl = getUpdatedUrl({
        filtersFromUrl,
        asPath,
        isFacetedNavigationEnabled,
        seoFacetedNavigationConfig,
        cleanUrlObj,
      });
      setUpdatedUrlActn({ updatedUrl });
    },
    [appliedFilters]
  );

  const removeAllFilters = () => {
    Object.keys(appliedFilters).forEach((filter) => {
      if (filter !== 'sort') {
        updateBopisFormValue(filter, []);
      }
    });
    const { asPath, filtersFromUrl } =
      getParams({
        formData: {},
        isFacetedNavigationEnabled,
        pathName,
        seoFacetedNavigationConfig,
        cleanUrlObj,
      }) || {};
    const updatedUrl = getUpdatedUrl({
      filtersFromUrl,
      asPath,
      isFacetedNavigationEnabled,
      seoFacetedNavigationConfig,
      cleanUrlObj,
    });
    setPriceFilterFlagActn(true);
    setUpdatedUrlActn({ updatedUrl });
  };

  return [selectedTab, handleFilterSelection, removeAllFilters];
};

export default useQuickFilters;
